export const SAVED_DISPLAY_WARNING = 'saved, but display is out of sync';

export function readDisplaySync(data: any): {
  displayOutOfSync: boolean;
  warning: string | null;
  serviceId: string | null;
} {
  const rawId = data?.service?.id || data?.id || data?.serviceId || null;
  const serviceId = rawId ? String(rawId) : null;
  if (data?.displayOutOfSync === true) {
    const warning = typeof data.warning === 'string' && data.warning.trim()
      ? data.warning
      : SAVED_DISPLAY_WARNING;
    return { displayOutOfSync: true, warning, serviceId };
  }
  return { displayOutOfSync: false, warning: null, serviceId };
}
